module.exports = __webpack_public_path__ + "static/banner-illustration-a7486b3fbdb02f4de05a79bdea9a3e1b.svg";